<template>
  <div :class="['app-shell', 'env-local']">
    <!-- <div class="env-badge" role="status" aria-live="polite">
      <span class="env-dot"></span>
      <span class="env-label">Beta</span>
    </div> -->

    <!--
    <div id="menu">
      <button class="menu-item" @click="navigateTo(0)">Hauptbereich</button>
      <button class="menu-item" @click="navigateTo(1)">Editierbereich</button>
    </div>-->
    <c_Login v-show="menuState == 0" />
    <c_Main ref="configurator" v-show="menuState == 1" />
    <c_Dashboard ref="dashboard" v-show="menuState == 3" />
    <c_ProfileData ref="profile" v-show="menuState == 4" />
  </div>
</template>

<script>
import c_Login from './components/LoginComponent.vue';
import c_Main from './components/MainComponent.vue';
import c_Dashboard from './components/DashboardComponent.vue';
import c_ProfileData from './components/ProfileDataComponent.vue';
import '@fortawesome/fontawesome-free/css/all.css'; 

export default {
  name: 'App',
  components: {
      c_Login,
      c_Main,
      c_Dashboard,
      c_ProfileData
  },
  data() {
    return {
      // 
      menuState: 0,
      loggedInUser: null,
      company: null,
      contactPerson: null,
      selectedProject: null,
    };
  },
  methods: {
    setLoggedInUser(user) {
      this.loggedInUser = user;
    },  
    getLoggedInUser() {
      return this.loggedInUser;
    },
    setCompany(company) {
      this.company = company;
    },  
    getCompany() {
      return this.company;
    },
    setContactPerson(contactPerson) {
      this.contactPerson = contactPerson;
    },  
    getContactPerson() {
      return this.contactPerson;
    },
    setSelectedProject(project) {
      this.selectedProject = project;
    },
    getSelectedProject() {
      return this.selectedProject;
    },
    navigateTo(route) {
      // Logik für die Navigation.
      // Sie könnten eine if-Abfrage verwenden, um zu prüfen, welche Route angefragt wurde, 
      // und dann die entsprechende Aktion ausführen.
      this.menuState = route;
    },
    changeMenuState(menuState) {
      this.menuState = menuState;

      if (this.menuState == 1) {
        this.$refs.configurator.refreshProject();
      }
      else if (this.menuState == 3) {
        this.$refs.dashboard.refreshDashboard();
      }
      else if (this.menuState == 4) {
        this.$refs.profile.refreshProfileData();
      }

      // Immer nach dem State nach oben scrollen
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  },
  computed: {
    stage() {
      return (process.env.VUE_APP_STAGE || 'LOCAL').toUpperCase();
    },
    stageClass() {
      return `env-${this.stage.toLowerCase()}`;
    },
    stageLabel() {
      return this.stage;
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.app-shell {
  position: relative;
  min-height: 100vh;
}

.env-badge {
  position: fixed;
  top: 12px;
  left: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: 999px;
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  z-index: 2000;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.16);
  background: linear-gradient(120deg, #334155, #475569);
}

.env-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.18);
}

.env-beta .env-badge {
  background: linear-gradient(120deg, #b91c1c, #ef4444);
}

.env-live .env-badge {
  background: linear-gradient(120deg, #065f46, #10b981);
}

.env-local .env-badge {
  background: linear-gradient(120deg, #334155, #475569);
}

#menu {
  display: flex;
  justify-content: space-around;
  background-color: #f8f9fa;
  padding: 10px 0;
}

.menu-item {
  margin: 0 20px;
  padding: 10px 20px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

.menu-item:hover {
  background-color: #0056b3;
}
</style>
